import { render } from "./InformationAlert.vue?vue&type=template&id=2b88f70e"
import script from "./InformationAlert.vue?vue&type=script&lang=js"
export * from "./InformationAlert.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__